export enum SETTINGS  {
    USE_SPLIT_TEXTFIELDS_TIMEREPORT = 'USE_SPLIT_TEXTFIELDS_TIMEREPORT',
};
